module.exports = "<h2>{{'menu.catalog.products.delete.title' | translate}}</h2>\n\n<p>\n  {{description}}<br/>\n  {{'menu.catalog.products.delete.body.notice' | translate}}\n</p>\n\n<div class=\"action-footer\">\n  <button class=\"button secondary\" ng-click=\"cancel()\">{{'common.buttons.cancel' | translate}}</button>\n  <button class=\"button\" ng-click=\"delete()\">{{'common.buttons.delete' | translate}}</button>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/menu/catalog/catalog.delete.modal.html
 ** module id = 599
 ** module chunks = 0
 **/